import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root',
})
export class CookieStorageService {
  constructor(
    private cookieService: CookieService,
  ) {}

  static readonly cookieCulture = 'N0_CULTURE';
  static readonly lastSearchCookie = 'N0_LAST_SEARCH';

  getItem(key: string): string | undefined {
    return this.cookieService.get(key);
  }

  setItem(key: string, value: string, maxAge?: number, path?: string): void {
    this.cookieService.set(key, value, maxAge, path ?? '/');
  }

  setObjectItem(key: string, value: unknown, expires?: number | Date, path?: string): void {
    this.cookieService.set(key, JSON.stringify(value), expires, path ?? '/');
  }

  removeCookie(key: string): void {
    this.cookieService.delete(key)
    const check = this.cookieService.get(key);
    if (check) this.cookieService.delete(key, '/');
  }

  removeAllCookies() {
    this.cookieService.deleteAll();
    localStorage.clear();
    sessionStorage.clear();
    window.location.reload();
  }
}
